import { LABEL_URL, BELIEVE_CONTROLLER_URL, JSONAPI_URL } from "../../services/common-urls";
import { MHTTPCL } from "../../services/http/http-client";

export const DBoxCostService = {
  updateCostHoldFlag: (cost_split_id, hold_flag) => MHTTPCL.post(LABEL_URL, {
    section: "releases",
    action: "update_cost_holdflag",
    cost_split_id: cost_split_id,
    hold_flag: hold_flag
  }),
  fetch: ({
    external_table,
    external_id,
    start,
    row_count = 100,
    str,
    cost_groups,
  }) => {
    if ((str == "" || str == undefined || str == null) && cost_groups == "[]") {
      console.log({'dbox-costs.service.js:20 cost_groups' : cost_groups});
      console.log({'dbox-costs.service.js:20 str' : str});
      return MHTTPCL.post(LABEL_URL, {
        section: 'releases',
        action: 'get_costs',
        external_table,
        external_id,

        start,
        row_count
      });
    } else {
      return MHTTPCL.post(LABEL_URL, {
        section: 'releases',
        action: 'filter_costs',
        external_table,
        external_id,
        str,
        cost_groups,

        start,
        row_count,
      })
    }
  },
  filterCosts: ({
    external_table,
    external_id,
    str,
    cost_groups,
    start,
  }) => MHTTPCL.post(LABEL_URL, {
    section: 'releases',
    action: 'filter_costs',
    external_table,
    external_id,
    str,
    cost_groups,
  }),
  getCosts: ({
    external_table,
    external_id,
    start,
  }) => MHTTPCL.post(LABEL_URL, {
    section: 'releases',
    action: 'get_costs',
    external_table,
    external_id,

    start,
  }),
  getAddCostData: ({
    cost_split_id = ""
  } = {}) => MHTTPCL.post(LABEL_URL, {
    section: 'releases',
    action: 'get_cost',
    cost_split_id,
  }),
  getCostDetails: ({
    cost_split_id
  }) => MHTTPCL.post(LABEL_URL, {
    section: 'releases',
    action: 'get_cost',
    cost_split_id,
  }).then(res => ({
    ...res,
    data: {
      ...res.data,
      cost: {
        ...res.data.cs,
        json_data: JSON.parse(res.data.cs.json_data) || {}
      },
      cs: undefined
    }
  })),
  saveCost: ({
    external_table,
    external_id,
    costData,
  }) => {
    return MHTTPCL.post(LABEL_URL, {
      ...costData,
      external_table,
      external_id,
      section: "releases",
      action: "submit_cost",
    });
  },
  deleteCost: (cost_split_id) => MHTTPCL.post(LABEL_URL, {
    section: 'releases',
    action: 'delete_cost',
    cost_split_id
  }),
  checkPostingNumber: ({
    external_id,
    external_table,
    cost_split_id,
    posting_number,
  }) => MHTTPCL.post(BELIEVE_CONTROLLER_URL, {
    action: 'is_unique_costsplit_posting_number',
    external_id,
    external_table,
    cost_split_id,
    posting_number,
  }),
  fetchAdvanceData: ({
    cost_split_id
  }) => MHTTPCL.post(LABEL_URL, {
    section: 'common',
    action: 'cost_advance_data',
    cost_split_id,
  }),
  fetchAdvanceDate: ({
    cost_split_id,
    royalty_account_id,
  }) => MHTTPCL.post(JSONAPI_URL, {
    action: 'advance_dates',
    cost_split_id,
    royalty_account_id,
  }),
  makeAccountAdvance: ({
    orig_curr = 'GDC',
    cost_group_id = '12',
    cost_amount_sys_curr = '4.500450045',
    cost_amount_orig_curr = '5000.00',
    cost_amount_roy_curr = '4.500450045',
    balance_date = '2013-07-01',
    amount = '-4.5',
    balance_type = '1',
    amount_sys_curr = '-4.5',
    description = 'Advance Compass, Dresses, Lover, Gone',
    cost_split_id = '6199',
    royalty_account_id = '94',
    contract_id = '144',
    debit_credit_flag = '1',
    external_id = '10202',
    external_table = 'release',
  }) => MHTTPCL.post(LABEL_URL, {
    section: 'common',
    action: 'account_advance',

    orig_curr,
    cost_group_id,
    cost_amount_sys_curr,
    cost_amount_orig_curr,
    cost_amount_roy_curr,
    balance_date,
    amount,
    balance_type,
    amount_sys_curr,
    description,
    cost_split_id,
    royalty_account_id,
    contract_id,
    debit_credit_flag,
    external_id,
    external_table,
  }),
  fetchCostReoupables: ({
    cost_split_id,
  }) => MHTTPCL.post(LABEL_URL, {
    section: 'common',
    action: 'cost_split_data',
    cost_split_id
  }),
  insertCostBalance: ({
    cost_split_id
  }) => MHTTPCL.post(LABEL_URL, {
    section: 'common',
    action: 'new_cost_balance',
    cost_split_id,
  }),
  removeBalance: ({
    balance_id
  }) => MHTTPCL.post(LABEL_URL, {
    section: 'royalty',
    action: 'delete_balance',
    balance_id,
  }),
  updateBalance: ({
    balance_id,
    amount,
    cost_split_id,
  }) => MHTTPCL.post(LABEL_URL, {
    section: 'common',
    action: 'update_balance_amount',
    balance_id,
    amount,
    cost_split_id,
  }),
  getRecoupableStatus: ({
    cost_split_id
  }) => MHTTPCL.post(LABEL_URL, {
    section: 'common',
    action: 'recoupable_status',
    cost_split_id
  }),
  uploadFile: (formData) => MHTTPCL.postFormData(LABEL_URL, formData),
  createCostSplit: ({
    cost_split_id
  }) => MHTTPCL.post(LABEL_URL, {
    section: 'common',
    action: 'create_cost_split',
    cost_split_id
  }),
  searchAccounts: (search) => MHTTPCL.get(LABEL_URL, {
    section: 'royalty',
    action: 'search_accounts',
    search
  }),
  searchContracts: (search) => MHTTPCL.get(LABEL_URL, {
    section: 'royalty',
    action: 'search_contracts',
    search
  }),
  modifyBalance: (balance_id, name, value) => MHTTPCL.modify(
    undefined,
    balance_id,
    name,
    value,
    "l_balances")
}
// Project ID:
// 321
// posting type:
// POTY
// Contract Type:
// Individual
// posting number:
// 12937

// ID Prod:
// 2
// Site:
// www.google.com
// Legal Company:
// Believe Digital Canada Inc
// Accounting Date:
// Recharge Code:
// 32
// Referential:
// 23124
// Cost Center:
// Social Account:
// dawd
// Destination:
// Destina
// Analytical Account:
// 5234213
// Recharge Type:
// Recharge
// REP Account:
// 231398
// Comment:
const demo = {
  "external_table": "release",
  "external_id": "10202",
  "date": "2021-05-10",
  "description": "Yeeee",
  "cost_group_id": "25",
  "currency": "GDC",
  "amount_orig_curr": "14123",
  "exchange_rate": "1111.00000",
  "amount": "12.7119711971",
  "payment_date": "2021-05-04",
  "section": "releases",
  "action": "submit_cost",
  json_data_str: { "posting_description": "Good Dec", "rep_grp_2": "98yu", "rep_grp_3": "9876", "referential_currency": "JPY", "referential_amount": "512345", "id_project": "321", "contract_type": "Individual", "id_prod": "2", "company": "abc", "recharge_code": "32", "cost_center": "", "destination": "Destina", "posting_type": "POTY", "posting_number": "12937", "site": "www.google.com", "accounting_date": "", "referential": "23124", "social_account": "dawd", "analytical_account": "5234213", "rep_account": "231398", "details_recharge_type": "recharge" },
};

const cs = {
  "account_to_promoter_flag": null,
  "accounting_date": null,
  "advance_type_id": null,
  "amount_orig_curr": "14123.00",
  "amount": "12.711971197",
  "amount2": null,
  "channel_id": null,
  "company": null,
  "cost_group_id": 25,
  "cost_id": null,
  "cost_split_id": 6267,
  "created": "2021-05-05 09:11:14",
  "currency": "GDC",
  "date": "2021-05-10",
  "description": "Yeeee",
  "document_ref": null,
  "exchange_rate": "1111.0000000000",
  "external_data1": null,
  "external_data2": null,
  "external_data3": null,
  "external_data4": null,
  "external_id": 10202,
  "external_id2": null,
  "external_table": "release",
  "external_table2": null,
  "file_id": null,
  "hold_flag": null,
  "identifier": null,
  "invoice_id": null,
  "invoice_line_id": null,
  "json_data": "{\"site\":\"www.google.com\",\"cost_center\":\"\",\"destination\":\"Destina\",\"social_account\":\"dawd\",\"posting_number\":\"12937\",\"rep_grp_2\":\"98yu\",\"contract_type\":\"Individual\",\"accounting_date\":\"\",\"rep_account\":\"231398\",\"referential_amount\":\"512345\",\"recharge_code\":\"32\",\"details_recharge_type\":\"recharge\",\"rep_grp_3\":\"9876\",\"id_prod\":\"2\",\"analytical_account\":\"5234213\",\"posting_type\":\"POTY\",\"company\":\"abc\",\"referential_currency\":\"JPY\",\"id_project\":\"321\",\"referential\":\"23124\",\"posting_description\":\"Good Dec\"}",
  "last_modified": "2021-05-05 09:11:14",
  "manual_recoupment_flag": null,
  "marketing_type_id": null,
  "paid_by_promoter_flag": null,
  "payment_date": "2021-05-04",
  "qty": null,
  "recouped_flag": null,
  "statement_line_id": null,
};